import { APP_ACTION_TYPES, FILTER_ACTION_TYPES, INITIATIVE_ACTION_TYPES } from '../../config';

import appAction from './App.actions';
import initiativeAction from './Initiative.actions';
import filterAction from './Filters.actions';

export const APP_ACTIONS = appAction[APP_ACTION_TYPES.PREFIX];
export const INITIATIVE_ACTIONS = initiativeAction[INITIATIVE_ACTION_TYPES.PREFIX];
export const FILTER_ACTIONS = filterAction[FILTER_ACTION_TYPES.PREFIX];
